module.exports = __webpack_public_path__ + "static/img/ichat_pic3.902d8d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/ichat_pic3.jpg
// module id = 623
// module chunks = 0